// eslint-disable-next-line import/prefer-default-export
import { billingTypes } from '../opportunities/constants';

const VERBAL_AGREEMENT = 'Verbal Agreement';
const SIDE_LETTER = 'Side Letter';
const WKZ_CONDITIONS = 'WKZ / Conditions';

export const agreementTypes = [
  { label: 'Verbal Agreement', value: VERBAL_AGREEMENT },
  { label: 'Side Letter', value: SIDE_LETTER },
  { label: 'WKZ Conditions', value: WKZ_CONDITIONS },
];

const EXTERNAL = billingTypes.find(({ value }) => value === 'External').label;
const WKZ = billingTypes.find(({ value }) => value === 'WKZ').label;

export const agreementTypeToBillingType = {
  [VERBAL_AGREEMENT]: EXTERNAL,
  [SIDE_LETTER]: EXTERNAL,
  [WKZ_CONDITIONS]: WKZ,
};

export const agreementFilterFields = ['name'];
export const agreementSelectLabel = object => object.name;
